import {
  opportunitiesListOptions,
  opportunitiesPipelinesRetrieveOptions
} from '@crm/api'
import {
  InfoPopover,
  OpportunitiesTable,
  OpportunityHeader
} from '@crm/components'

import { OpportunitiesFilter } from '@crm/features/opportunities/components'
import { TitleSection } from '@shared/components'
import { useQueryParams } from '@shared/hooks'

import { useLocales } from '@shared/locales'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

export const Opportunities = () => {
  const params = useQueryParams()
  const { id } = useParams()
  const { t } = useLocales()

  const { data, isLoading } = useQuery(
    opportunitiesListOptions({
      query: {
        ...params,
        ...(id && { pipeline: [Number(id)] })
      }
    })
  )

  const { data: pipeline, isLoading: isLoadingPipeline } = useQuery({
    ...opportunitiesPipelinesRetrieveOptions({
      path: { id: Number(params.pipeline) }
    }),
    enabled: !!params.pipeline
  })

  const pipelineName = pipeline?.name ? ` - ${pipeline?.name}` : ''

  return (
    <>
      <TitleSection
        title={`${t(`lead.opportunities`)} ${pipelineName}`}
        isLoading={isLoading || isLoadingPipeline}
        count={data?.count}
        extraTitle={
          pipeline && <InfoPopover responsible={pipeline?.responsible} />
        }
      />

      <OpportunitiesTable
        data={data}
        isLoading={isLoading}
        leftChildren={<OpportunitiesFilter />}
        rightChildren={<OpportunityHeader />}
      />
    </>
  )
}
